/** The shape migration 0043 constrains `players.country` / `guilds.country` to. */
const ISO_ALPHA2 = /^[A-Za-z]{2}$/;

/**
 * "DE" → "Germany", from the browser's own ICU data — no dictionary of country
 * names lives in this repository. The locale is fixed because the panel is
 * English-only. A code Intl does not know comes back as itself.
 */
const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

/** The upper-cased code, or null for anything that is not two letters. */
export function isoAlpha2(code: string): string | null {
  return ISO_ALPHA2.test(code) ? code.toUpperCase() : null;
}

/**
 * The country's English name; a value that is not a two-letter code stays on
 * screen as itself.
 */
export function countryName(code: string): string {
  const iso = isoAlpha2(code);
  return iso ? (regionNames.of(iso) ?? iso) : code;
}
